import DOMPurify from 'dompurify';
import { WHITELISTED_HTML_TAGS_FOR_TEXT_REPRESENTATION } from '../constants';

export default function sanitizeHTML(inputHTML: string): string {
  return DOMPurify.sanitize(inputHTML, {
    ALLOWED_TAGS: WHITELISTED_HTML_TAGS_FOR_TEXT_REPRESENTATION,
    ALLOWED_ATTR: [],
    ALLOW_DATA_ATTR: false,
    KEEP_CONTENT: true,
  });
}
